import {
  ActionIcon,
  type ActionIconProps,
  Badge,
  type BadgeProps,
} from "@mantine/core";
import React, { forwardRef } from "react";

import styles from "./Header.module.scss";

export const HeaderContainer: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.headerContainer} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const Sky: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.sky} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const Sea: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.sea} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const LogoContainer: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.logoContainer} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const HeaderIcon = forwardRef<HTMLButtonElement, ActionIconProps>(
  ({ className, ...props }, ref) => (
    <ActionIcon
      ref={ref}
      className={`${styles.headerIcon} ${className ?? ""}`}
      {...props}
    />
  ),
);
HeaderIcon.displayName = "HeaderIcon";

export const HeaderBadge = forwardRef<
  HTMLDivElement,
  BadgeProps & React.HTMLAttributes<HTMLDivElement>
>((props, ref) => (
  <div className={styles.headerBadgeWrapper}>
    <Badge ref={ref} className={styles.headerBadge} {...props} />
  </div>
));
HeaderBadge.displayName = "HeaderBadge";

export const JustifyEnd: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.justifyEnd} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const FlexDiv: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.flexDiv} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);
